import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import * as userApi from "../services/userService"
import {AuthContextType, CommonComponentState} from "../types/types";
import {Loader} from "../components/loader/Loader";
import { setServiceRegistry } from "../stateManagement/actions/serviceRegistryActions";
import { getAndSetRefreshTokenConfig, getRefreshToken, setAuthContextInStorage } from "../services/authenticationService";
import { EnvironmentRegistry } from "../services/registry/environmentRegistry";


export type AuthActions = {
    signInByToken: (token: string, env: string) => Promise<AuthContextType>
}

const AuthContext = createContext<AuthContextType & AuthActions>(
    {} as AuthContextType & AuthActions
);


export function AuthProvider({children}: { children: ReactNode }) {
    const [searchParams] = useSearchParams();
    const [authContext, setAuthContext] = useState<AuthContextType>({} as AuthContextType);
    const [state, setState] = useState<CommonComponentState>({loading: true});
    useEffect(() => {
        getAndSetCurrentUser();
        // eslint-disable-next-line
    }, [])

    async function getContextFromStorage() {
        const isRefreshTokenEnabled = localStorage.getItem("refreshToken");
        if(!isRefreshTokenEnabled){
            let item = localStorage.getItem("authContext");
            if (item) {
                return JSON.parse(item);
            } else {
                throw  new Error("Could not find valid token");
            }
        }else{
            // get token from refresh api
            // getContextFromApi()
            // return context
            const token = sessionStorage.getItem("access_token");
            const env = EnvironmentRegistry.getEnvironment();
            if(token && env){
               const context = await getContextFromApi(token,env);
               return context;
            }else if(env){
                const response = await getRefreshToken();
                const refreshedToken = response?.token;
                const context = await getContextFromApi(refreshedToken,env);
                return context;
            }else{
                throw new Error("Environment not found");
            }
        }
    }

    async function getContextFromApi(token: string, env: string) {
        const user = await userApi.getUserFromToken(token, env);
        return {
            user: user,
            env: env,
            token

        };
    }

    async function signInByToken(token: string, env: string) {
        const context = await getContextFromApi(token, env);
        localStorage.setItem("authContext", JSON.stringify(context))
        localStorage.setItem("access_token", context.token);
        setAuthContext(context)
        return context;
    }

    async function getAndSetCurrentUser() {
        try {
            await getAndSetRefreshTokenConfig();
            const token = searchParams.get("token") as string;
            const env = searchParams.get("env") as string;
            // await delay(10000);
            let context = null;
            if (!token || !env) {
                console.log("could not find token and env")
                context = await getContextFromStorage()
            } else {
                context = await getContextFromApi(token, env);
            }
            
            // localStorage.setItem("access_token", context.token);
            setAuthContextInStorage(context);
            setAuthContext(context)
            if (token && env) {
                setServiceRegistry();
            }
        } catch (error) {
            console.log(error);
            setState({...state, error: "Could not authenticate User"})
        } finally {
            setState({...state, loading: false})
        }
    }

    if (state.loading) {
        return <Loader size={"xl"}/>
    }

    // if (state.error) {
    //     return <ErrorPage description={state.error}/>
    // }

    return (
        <AuthContext.Provider value={{...authContext, signInByToken}}>
            {children}
            {/*{authContext.user ? children : <ErrorPage description="Could not find active User session"/>}*/}
        </AuthContext.Provider>
    );


}

export function useAuth(): AuthContextType & AuthActions {
    return useContext(AuthContext);
}
